import { addYears } from "date-fns";

export const TOKEN_KEY = "TOKEN_KEY";

export const tokenExpirationDate = addYears(new Date(), 10);
